
import { executeSearch, performFulltextSearch } from './app-initialization.search.js';

export async function initializeFormSubmit() {
    let mainForm = $('.fnd_searchform').first();
    if (mainForm.length === 0) mainForm = $('#search-form, .search-form, form[action*="search"]').first();
    if (mainForm.length > 0) mainForm.off('submit.appInit').on('submit.appInit', handleFormSubmit);

    const filterForms = $('.filter-form, form[data-filter="true"]');
    if (filterForms.length > 0) filterForms.off('submit.appInit').on('submit.appInit', handleFilterFormSubmit);
}

export function handleFormSubmit(event) {
    event.preventDefault();
    const form = $(event.target);
    const searchInput = $('#fnd_searchbox, input[name="sq"], input[name="search"]').first();
    const query = (searchInput.val() || '').toString().trim();
    if (!query) return;
    
    // Check if user is authenticated - block fulltext search for guests
    const isAuthenticated = !!(window.SERVER_AUTH_STATUS && window.SERVER_AUTH_STATUS.isAuthenticated);
    if (!isAuthenticated) {
        // Redirect to login with proper next parameter
        try {
            const url = new URL(window.location.href);
            url.searchParams.set('sq', query);
            url.hash = 'fulltext';
            const currentUrl = url.pathname + url.search + url.hash;
            window.location.href = `/login?next=${encodeURIComponent(currentUrl)}`;
        } catch(_) {
            const currentUrl = window.location.pathname + (window.location.search || '') + '#fulltext';
            window.location.href = `/login?next=${encodeURIComponent(currentUrl)}`;
        }
        return;
    }
    
    // Update URL with query and hash through debounced mechanism
    // Hash will be updated through updateUrlWithFilters with 2-second debounce
    if (window.filterController && typeof window.filterController.updateUrlWithFilters === 'function') {
        window.filterController.activeFilters.searchQuery = query;
        window.filterController.updateUrlWithFilters(true, '#fulltext'); // immediate=true, desiredHash='#fulltext'
    }
    
    try {
        const btn = document.getElementById('nav-full-text-card-tab');
        if (btn && window.bootstrap && typeof window.bootstrap.Tab === 'function') { new window.bootstrap.Tab(btn).show(); }
    } catch(_) {}
    if (window.searchApi && window.axios) { performFulltextSearch(query); } else { executeSearch(query); }
}

export function handleFilterFormSubmit(event) {
    event.preventDefault();
    if (window.updateFilters && typeof window.updateFilters === 'function') window.updateFilters();
}


